import React from 'react'
import MicroFrontend from "../MicroFrontend"

const ContactSalesPopup = ({ history, data }) => {
    return (
        <MicroFrontend
            name="ContactSalesPopup"
            history={history}
            data={data}
        />
    )
}

export default (ContactSalesPopup);
